import {
    ActivityCountEvent,
    EmbedEvent,
} from 'embed/types/events'
import React, {
    useContext,
    useEffect,
} from 'react'
import {
    getActivityCount,
    getHighlightCount,
} from 'selectors/ninchat'
import {EmbedContext} from 'components/EmbedContext'
import {useAppSelector} from 'hooks'
import {useSendToParent} from 'embed/utils/event'


const EmbedActivities = () => {
    const embed = useContext(EmbedContext)
    const sendToParent = useSendToParent()

    const activityCount = useAppSelector(({
        ninchat, ui,
    }) => getActivityCount(ninchat, ui.queue_pickup_delays))
    const highlightCount = useAppSelector(({
        ninchat, ui,
    }) => getHighlightCount(ninchat, ui.queue_pickup_delays))

    useEffect(() => {
        const targetOrigin = embed?.targetOrigin

        if (!targetOrigin) {
            return
        }

        const activityCountEvent: ActivityCountEvent = {
            activity: activityCount,
            event: EmbedEvent.ActivityCount,
            highlights: highlightCount,
            targetOrigin,
        }

        sendToParent(activityCountEvent)
    }, [activityCount, highlightCount])

    return <div />
}

export default EmbedActivities
